import Keycloak from "keycloak-js";

const keycloak = new Keycloak({
  url: process.env.REACT_APP_KEYCLOAK_BASE_URL,
  realm: process.env.REACT_APP_KEYCLOAK_REALM || "<missing realm>",
  clientId: "claim-portal",
});

export default keycloak;
